function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "tone\\u9996\\u9875",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\u7CFB\\u7EDF\\u4ECB\\u7ECD-3",
  transform: "translate(-787.000000, -271.000000)",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\u7F16\\u7EC4",
  transform: "translate(126.000000, 100.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\u7F16\\u7EC4-9",
  transform: "translate(11.000000, 140.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\u7F16\\u7EC4-7",
  transform: "translate(56.000000, 27.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\u5B9A\\u4F4D",
  transform: "translate(594.000000, 4.000000)"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-1",
  fill: "#1C8AEC",
  opacity: 0.400000006,
  points: "11.4284571 0 11.4284571 9.16414653 36.5724571 9.16414653 27.4284571 0"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-2",
  fill: "#1C8AEC",
  points: "0 55 64 55 64 9.17812185 0 9.17812185"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-4",
  fill: "#181818",
  points: "0 0 0 9.16414653 25.1428571 9.16414653 16 0"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-5",
  fill: "#FFFFFF",
  points: "20.7969143 43.2678305 9.52262857 31.9661468 20.7969143 20.6656086 23.2209143 23.095253 14.3706286 31.9661468 23.2209143 40.8381862"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-6",
  fill: "#FFFFFF",
  points: "43.2030857 43.2678305 40.7790857 40.8381862 49.6293714 31.9661468 40.7790857 23.095253 43.2030857 20.6656086 54.4773714 31.9661468"
})))))));

function SvgSec1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "55px",
    viewBox: "0 0 64 55",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u6784\u5EFA\u670D\u52A1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSec1);
export default __webpack_public_path__ + "static/media/sec_1.0782a2ac.svg";
export { ForwardRef as ReactComponent };